<template>
	<el-dialog class="el-dialogs" :close-on-click-modal="false" :visible.sync="dialogVisible" width="430px" append-to-body title="修改登陆密码" center>
		<el-form ref="form" label-position="left" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="新密码："  class="flex-row" required> <!-- comfirmPassword -->
        <el-input type="password" placeholder="请输入新密码" :maxlength="6" v-model="form.newPassword" class="w200"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" class="flex-row" required>
        <el-input type="password" placeholder="请再次输入密码" :maxlength="6" v-model="form.comfirmPassword" class="w200"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：" class="flex-row notCur">
        <el-input v-model="userInfo.mobile" readonly class="w200"></el-input>
      </el-form-item>
      <el-form-item label="短信验证码：" prop="verifyCode" class="flex-row">
        <div class="flex-row">
          
          <el-input placeholder="请输入验证码" :maxlength="6" v-model="form.verifyCode"  class="w200">
            <span slot="suffix" class="cur jishi" @click="addLoginCode" :disabled="!codeName"><el-divider direction="vertical"></el-divider>{{ codeName ? '获取验证码':time+'s'}}</span>
          </el-input>
        </div>
      </el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="save">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import Dialog from './dialog.vue'
import {decrypt,encrypt} from '../../assets/javascript/untils'
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				}else if(value.length<6){
					callback(new Error('密码不能小于6位'));
				}
				else if (value.length>=6&&this.form.oldPass !== '') {
					
					// this.$api.get('/oxUser/checkOldPass',{ oldPass:this.form.oldPass} ).then(res => {
					// 	if (!res) {
					// 		callback(new Error('密码错误,请输入正确密码'));
					// 	}else{
					// 		callback();
					// 	}
					// })

				}
			};
			var validateNewPass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入确认密码'));
				}else if(value.length<6){
					callback(new Error('密码不能小于6位'));
				} else if (value !== this.form.newPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				dialogVisible: false,
				codeName: true,
				time: 60,
        rules: {
          verifyCode: [{required: true,  message: "请输入验证码", trigger: 'blur' }],
          newPassword: [{
              required: true,
              message: "请输入新密码",
              trigger: 'blur'
          }, {
              min: 6,
              message: '密码不能小于6位',
              trigger: 'change'
          }, {
              min: 6,
              message: '密码不能小于6位',
              trigger: 'blur'
          }],
					comfirmPassword: [
						{required: true, validator: validateNewPass, trigger: 'blur' }
					]
				},
				appInfo: this.$store.getters.AppInfo,
				imgCode: '',
				imgUrl: '',
				userInfo: {},
				form: {
          newPassword: '',
					comfirmPassword: '',
					verifyCode: '',
					millisecond: new Date().getTime()
				}
			}
		},
		mounted() {
			this.$on('open', function(org) {
				this.userInfo = org
				this.dialogVisible = true;
			});
		},
		components: {Dialog},
		computed: {},
		created(){
			// this.getvCode();
		},
		methods: {
			getvCode(){
				this.$api.post(this.$url.getImg).then( res => {
          this.imgUrlKey = res.key;
          this.imgUrl = res.imageBaseCode;
        })
			},
			timestamp(url) {
        var getTimestamp = new Date().getTime();
        if (url.indexOf("?") > -1) {
					url = url + "&timestamp=" + getTimestamp
				} else {
					url = url + "?timestamp=" + getTimestamp
				}
        return url;
			},
			addLoginCode(){
				let arr = encrypt(JSON.stringify({
          mobile: this.userInfo.mobile,
          bizType: 'changeloginpwd',
					millisecond: new Date().getTime()
        }));
        this.$api.post(this.$url.send,arr).then(resp => {
          if (resp) {
            this.codeName = false;
						this.$message.success("短信发送成功")
          } else {
            this.codeName = true;
						clearInterval(auth_timetimer);
          }
					this.time = 60;
				})
				let auth_timetimer =  setInterval(() => {
          if (this.time <= 0) {
            this.time = 60;
            this.codeName = true;
            clearInterval(auth_timetimer);
          }
          this.time--;
        }, 1000);
			},
			save() {
				if(this.form.newPassword == ''){
          this.$message.error('请输入新密码');
          return false;
				}
				if(this.form.comfirmPassword == ''){
          this.$message.error('请输入确认密码');
          return false;
				}
				if(this.form.newPassword !== this.form.comfirmPassword){
          this.$message.error('2次密码输入不一致');
          return false;
        }
        if(this.form.newPassword < 6 && this.form.comfirmPassword < 6){
          this.$message.error('密码不能低于6位数');
          return false;
        }
				let arr = encrypt(JSON.stringify(this.form));
				this.$api.post(this.$url.changeloginpwd, arr).then(res => {
					if (res) {
						this.$api.success("修改密码成功")
						this.dialogVisible = false;
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.btn {
	line-height: 30px;
}
div .el-dialog__footer {
	border: 0;
}
/deep/ .el-dialog__body {
	padding: 10px 20px;
}
.notCur  /deep/ .el-input__inner{
  cursor: not-allowed;
}
</style>
